import { URI_ACCOUNTING_CASH } from '@/config/config';

export default async ({ rootState }, payload) => {
  const token = rootState['DATA-ACCESS'].tokenAuth;
  const opts = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  };

  const response = await fetch(
    `${URI_ACCOUNTING_CASH}open/cash-reinforcement`,
    opts,
  );
  const jsonResult = await response.json();

  if (response.status >= 400) {
    return Promise.reject(jsonResult.message);
  }
  return jsonResult;
};
